import { render, staticRenderFns } from "./coffee-detail-home.vue?vue&type=template&id=1fd45494&scoped=true&"
import script from "./coffee-detail-home.vue?vue&type=script&lang=js&"
export * from "./coffee-detail-home.vue?vue&type=script&lang=js&"
import style0 from "./coffee-detail-home.vue?vue&type=style&index=0&id=1fd45494&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd45494",
  null
  
)

export default component.exports